<style lang="less" scoped>
@import "./swLayer.less";
</style>
<template>
  <div class="swContainner">
     <div class="inherent">
         <div style="position:absolute;height:100%">
      <div class="Info">
        <info type='sw' />
      </div>
      <!-- <div class="progress">
        <progressM type='sw' />
      </div> -->
      <div class="alarm">
          <alarm type='sw' />
        </div>
      <div class="survey">
         <survey type='sw' />
      </div>
      <div class="transportOverview">
         <transportOverview type='sw' />
      </div>
      <div class="backconrt">
        <backconrtM type='sw' />
      </div>
      </div>
      <div class="frontcon" :class="onlyOneImg==1?'onlyOneImg':'notOnlyOne'">
         <frontconrtM type='sw' @onlyOne='changeImg'/>
      </div>
    </div>
    
  </div>
</template>

<script>
import mix from "./swLayer-mixins";
export default {
  mixins: [mix]
};
</script>


// WEBPACK FOOTER //
// src/components/swLayer/swLayer.vue